module.exports = __webpack_public_path__ + "static/scale-model-of-the-magicians-agency-theatre-in-san-antonio-texas-88ec5b6b079a2aee0eb939623172b359.png";